import React, { useEffect, useState } from 'react';
import ApplicationStatus from '../../../Common/ApplicationStatus';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_ESIGN_AUTH_KEY } from '../../../../../sessionStorage'
import IsJuvenile from '../../../../Helpers/Dates/IsJuvenile';

import './Status.scss';

export default function Status(props) {

  const [statusResponse, setStatusResponse] = useState(null);

  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
  const isJuvenile = IsJuvenile(props.formState.pages.basicInfo.birthdate);
  const esignAuth = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY));

  const passcode = (props.formState.pages.insuredInfo.socialSecurityNumber && props.formState.pages.insuredInfo.socialSecurityNumber.replace(/-/g, '').substring(5))
    || (esignAuth && esignAuth.passcode);
  const birthdate = (isJuvenile ? props.formState.pages.insuredInfo.ownerBirthdate : props.formState.pages.basicInfo.birthdate)
    || (esignAuth && esignAuth.birthdate);
  const applicationID = props.formState.pages.consent.appIdentifier
    || (esignAuth && esignAuth.applicationID);

  useEffect(() => {
    fetch(`${covrServicesUrl}/api/AppStatus/GetAppStatus?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(json => setStatusResponse(json));
  }, [])

  const downloadPDF = () => {
    fetch(`${covrServicesUrl}/api/AppStatus/GetAppPDF?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`)
      .then(response => {
        response.blob().then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Application.pdf';
          a.click();
        });
      });
  }

  const sendStatusEmail = () => {
    fetch(`${covrServicesUrl}/api/AppStatus/SendStatusEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify({
        passcode: passcode,
        birthdate: birthdate,
        applicationID: applicationID,
        clientUserID: statusResponse.ClientUserID,
      }),
    });
  }

  return (
    <div>
      {statusResponse != null && <ApplicationStatus
        insuredName={statusResponse.InsuredName}
        coverageAmount={statusResponse.Coverage}
        status={statusResponse}
        premium={statusResponse.Premium}
        email={statusResponse.EmailAddress}
        statusId={statusResponse.CaseStatusID}
        policyNumber={statusResponse.PolicyNumber}
        policyDate={statusResponse.PolicyDate}
        productName={statusResponse.ProductName || "Secure Promise Whole Life"}
        downloadPDF={downloadPDF}
        sendStatusEmail={sendStatusEmail}
      />
      }

    </div>
  )
}
